import { gql } from "@apollo/client";

export const getEngagementSummary = gql`
  query GetEngagementSummary($campaignIds: [String!]) {
    getEngagementSummary(summaryCampaignIds: $campaignIds) {
      campaignId
      summary {
        successCount
        failureCount
      }
    }
  }
`;
